import BaseModel from '@/data/BaseModel';

import moment from 'moment-timezone';

export const LOADING_DATA = 'LOADING_DATA';
export const READY_FOR_ADMIN = 'READY_FOR_ADMIN';
export const ADMIN_IMPLEMENTATION = 'ADMIN_IMPLEMENTATION';
export const CUTOVER = 'CUTOVER';

export type RipplingMigrationStep =
  | typeof LOADING_DATA
  | typeof READY_FOR_ADMIN
  | typeof ADMIN_IMPLEMENTATION
  | typeof CUTOVER;

export interface TagConfig {
  tag: string;
  migration_window_days: number;
  comms_entries: Array<{
    templateName: string;
    triggerDaysLeft: number;
    requiresCutoverScheduled: boolean;
  }>;
}

export interface RipplingMigrationStatusFields {
  status: RipplingMigrationStep;
  account_id: number;
  tag: string | null;
  migration_started_at: string;
  migration_completed_at: string;
  cutover_time: string;
  tag_config: TagConfig | null;
}

class RipplingMigrationStatus extends BaseModel<RipplingMigrationStatusFields>({
  status: LOADING_DATA,
  account_id: 0,
  tag: null,
  migration_started_at: '',
  migration_completed_at: '',
  cutover_time: '',
  tag_config: null,
}) {
  // Yes we have model.date() but it internally it is implemented such that invalid dates return the current timestamp
  // when what we want is a valid date or nothing, which is too large and widespread of an issue to fix currently.
  date<T extends 'saving' | keyof RipplingMigrationStatusFields>(field: T) {
    const dateStr = this.get(field, null) as string | null;
    const date = moment(dateStr);
    if (date.isValid()) {
      return date;
    }

    return null;
  }
}

export default RipplingMigrationStatus;
